<section class="coach">
  <div class="coach__header">
    <span class="coach__header__pupil">
      <app-privilege-icon [student]="choicedPupil" [lesson]="null"></app-privilege-icon>
      <p>{{ choicedPupil.name }} <br> {{ choicedPupil.middle_name }}</p>
    </span>
    <span><h1 class="coach__header__title">Кто твой <span>Коуч?</span></h1></span>
    <span class="coach__header__habirint-logo">
      <img src="/assets/images/habirint_white.svg" alt="">
      <p>Хабиринт</p>
    </span>
  </div>
  <div class="coach__body">
    <app-pupil-choice [coach]="true" [choicedPupil]="choicedPupil"></app-pupil-choice>
  </div>
</section>
